function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import RequestClient, { authErrorStatusCode } from "./RequestClient.js";

// TODO: remove deprecated options in next major release

var getName = function getName(id) {
  return id.split('-').map(function (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }).join(' ');
};
function getOrigin() {
  // eslint-disable-next-line no-restricted-globals
  return location.origin;
}
function getRegex(value) {
  if (typeof value === 'string') {
    return new RegExp("^".concat(value, "$"));
  }
  if (value instanceof RegExp) {
    return value;
  }
  return undefined;
}
function isOriginAllowed(origin, allowedOrigin) {
  var patterns = Array.isArray(allowedOrigin) ? allowedOrigin.map(getRegex) : [getRegex(allowedOrigin)];
  return patterns.some(function (pattern) {
    return (pattern == null ? void 0 : pattern.test(origin)) || (pattern == null ? void 0 : pattern.test("".concat(origin, "/")));
  }); // allowing for trailing '/'
}
var _refreshingTokenPromise = /*#__PURE__*/_classPrivateFieldLooseKey("refreshingTokenPromise");
var _getAuthToken = /*#__PURE__*/_classPrivateFieldLooseKey("getAuthToken");
var _getPlugin = /*#__PURE__*/_classPrivateFieldLooseKey("getPlugin");
var Provider = /*#__PURE__*/function (_RequestClient) {
  _inherits(Provider, _RequestClient);
  function Provider(uppy, opts) {
    var _this;
    _classCallCheck(this, Provider);
    var _opts$supportsRefresh;
    _this = _callSuper(this, Provider, [uppy, opts]);
    Object.defineProperty(_assertThisInitialized(_this), _getPlugin, {
      value: _getPlugin2
    });
    Object.defineProperty(_assertThisInitialized(_this), _getAuthToken, {
      value: _getAuthToken2
    });
    Object.defineProperty(_assertThisInitialized(_this), _refreshingTokenPromise, {
      writable: true,
      value: void 0
    });
    _this.provider = opts.provider;
    _this.id = _this.provider;
    _this.name = _this.opts.name || getName(_this.id);
    _this.pluginId = _this.opts.pluginId;
    _this.tokenKey = "companion-".concat(_this.pluginId, "-auth-token");
    _this.companionKeysParams = _this.opts.companionKeysParams;
    _this.preAuthToken = null;
    _this.supportsRefreshToken = (_opts$supportsRefresh = opts.supportsRefreshToken) != null ? _opts$supportsRefresh : true; // todo false in next major
    return _this;
  }
  _createClass(Provider, [{
    key: "headers",
    value: function () {
      var _headers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, headers, token, authHeaders;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([_get(_getPrototypeOf(Provider.prototype), "headers", this).call(this), _classPrivateFieldLooseBase(this, _getAuthToken)[_getAuthToken]()]);
            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              headers = _yield$Promise$all2[0];
              token = _yield$Promise$all2[1];
              authHeaders = {};
              if (token) {
                authHeaders['uppy-auth-token'] = token;
              }
              if (this.companionKeysParams) {
                authHeaders['uppy-credentials-params'] = btoa(JSON.stringify({
                  params: this.companionKeysParams
                }));
              }
              return _context.abrupt("return", _objectSpread(_objectSpread({}, headers), authHeaders));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function headers() {
        return _headers.apply(this, arguments);
      }
      return headers;
    }()
  }, {
    key: "onReceiveResponse",
    value: function onReceiveResponse(response) {
      _get(_getPrototypeOf(Provider.prototype), "onReceiveResponse", this).call(this, response);
      var plugin = _classPrivateFieldLooseBase(this, _getPlugin)[_getPlugin]();
      var oldAuthenticated = plugin.getPluginState().authenticated;
      var authenticated = oldAuthenticated ? response.status !== authErrorStatusCode : response.status < 400;
      plugin.setPluginState({
        authenticated: authenticated
      });
      return response;
    }
  }, {
    key: "setAuthToken",
    value: function () {
      var _setAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(token) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _classPrivateFieldLooseBase(this, _getPlugin)[_getPlugin]().storage.setItem(this.tokenKey, token));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setAuthToken(_x) {
        return _setAuthToken.apply(this, arguments);
      }
      return setAuthToken;
    }()
  }, {
    key: "removeAuthToken",
    value: function () {
      var _removeAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _classPrivateFieldLooseBase(this, _getPlugin)[_getPlugin]().storage.removeItem(this.tokenKey));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function removeAuthToken() {
        return _removeAuthToken.apply(this, arguments);
      }
      return removeAuthToken;
    }()
    /**
     * Ensure we have a preauth token if necessary. Attempts to fetch one if we don't,
     * or rejects if loading one fails.
     */
  }, {
    key: "ensurePreAuth",
    value: (function () {
      var _ensurePreAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.companionKeysParams && !this.preAuthToken)) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return this.fetchPreAuthToken();
            case 3:
              if (this.preAuthToken) {
                _context4.next = 5;
                break;
              }
              throw new Error('Could not load authentication data required for third-party login. Please try again later.');
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function ensurePreAuth() {
        return _ensurePreAuth.apply(this, arguments);
      }
      return ensurePreAuth;
    }() // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    )
  }, {
    key: "authQuery",
    value: function authQuery(data) {
      return {};
    }
  }, {
    key: "authUrl",
    value: function authUrl(_ref) {
      var authFormData = _ref.authFormData,
        query = _ref.query;
      var params = new URLSearchParams(_objectSpread(_objectSpread({}, query), {}, {
        // This is only used for Companion instances configured to accept multiple origins.
        state: btoa(JSON.stringify({
          origin: getOrigin()
        }))
      }, this.authQuery({
        authFormData: authFormData
      })));
      if (this.preAuthToken) {
        params.set('uppyPreAuthToken', this.preAuthToken);
      }
      return "".concat(this.hostname, "/").concat(this.id, "/connect?").concat(params);
    }
  }, {
    key: "loginSimpleAuth",
    value: function () {
      var _loginSimpleAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref2) {
        var uppyVersions, authFormData, signal, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              uppyVersions = _ref2.uppyVersions, authFormData = _ref2.authFormData, signal = _ref2.signal;
              _context5.next = 3;
              return this.post("".concat(this.id, "/simple-auth"), {
                form: authFormData
              }, {
                qs: {
                  uppyVersions: uppyVersions
                },
                signal: signal
              });
            case 3:
              response = _context5.sent;
              this.setAuthToken(response.uppyAuthToken);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loginSimpleAuth(_x2) {
        return _loginSimpleAuth.apply(this, arguments);
      }
      return loginSimpleAuth;
    }()
  }, {
    key: "loginOAuth",
    value: function () {
      var _loginOAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref3) {
        var _this2 = this;
        var uppyVersions, authFormData, signal;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              uppyVersions = _ref3.uppyVersions, authFormData = _ref3.authFormData, signal = _ref3.signal;
              _context6.next = 3;
              return this.ensurePreAuth();
            case 3:
              signal.throwIfAborted();
              return _context6.abrupt("return", new Promise(function (resolve, reject) {
                var link = _this2.authUrl({
                  query: {
                    uppyVersions: uppyVersions
                  },
                  authFormData: authFormData
                });
                var authWindow = window.open(link, '_blank');
                var _cleanup;
                var handleToken = function handleToken(e) {
                  if (e.source !== authWindow) {
                    var jsonData = '';
                    try {
                      // TODO improve our uppy logger so that it can take an arbitrary number of arguments,
                      // each either objects, errors or strings,
                      // then we don’t have to manually do these things like json stringify when logging.
                      // the logger should never throw an error.
                      jsonData = JSON.stringify(e.data);
                    } catch (err) {
                      // in case JSON.stringify fails (ignored)
                    }
                    _this2.uppy.log("ignoring event from unknown source ".concat(jsonData), 'warning');
                    return;
                  }
                  var companionAllowedHosts = _classPrivateFieldLooseBase(_this2, _getPlugin)[_getPlugin]().opts.companionAllowedHosts;
                  if (!isOriginAllowed(e.origin, companionAllowedHosts)) {
                    reject(new Error("rejecting event from ".concat(e.origin, " vs allowed pattern ").concat(companionAllowedHosts)));
                    return;
                  }

                  // Check if it's a string before doing the JSON.parse to maintain support
                  // for older Companion versions that used object references
                  var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
                  if (data.error) {
                    var uppy = _this2.uppy;
                    var message = uppy.i18n('authAborted');
                    uppy.info({
                      message: message
                    }, 'warning', 5000);
                    reject(new Error('auth aborted'));
                    return;
                  }
                  if (!data.token) {
                    reject(new Error('did not receive token from auth window'));
                    return;
                  }
                  _cleanup();
                  resolve(_this2.setAuthToken(data.token));
                };
                _cleanup = function cleanup() {
                  authWindow == null || authWindow.close();
                  window.removeEventListener('message', handleToken);
                  signal.removeEventListener('abort', _cleanup);
                };
                signal.addEventListener('abort', _cleanup);
                window.addEventListener('message', handleToken);
              }));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function loginOAuth(_x3) {
        return _loginOAuth.apply(this, arguments);
      }
      return loginOAuth;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref4) {
        var uppyVersions, authFormData, signal;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              uppyVersions = _ref4.uppyVersions, authFormData = _ref4.authFormData, signal = _ref4.signal;
              return _context7.abrupt("return", this.loginOAuth({
                uppyVersions: uppyVersions,
                authFormData: authFormData,
                signal: signal
              }));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function login(_x4) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "refreshTokenUrl",
    value: function refreshTokenUrl() {
      return "".concat(this.hostname, "/").concat(this.id, "/refresh-token");
    }
  }, {
    key: "fileUrl",
    value: function fileUrl(id) {
      return "".concat(this.hostname, "/").concat(this.id, "/get/").concat(id);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this3 = this;
        var authTokenAfter,
          _args9 = arguments;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _classPrivateFieldLooseBase(this, _refreshingTokenPromise)[_refreshingTokenPromise];
            case 2:
              _context9.prev = 2;
              _context9.next = 5;
              return _get(_getPrototypeOf(Provider.prototype), "request", this).apply(this, _args9);
            case 5:
              return _context9.abrupt("return", _context9.sent);
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](2);
              if (this.supportsRefreshToken) {
                _context9.next = 12;
                break;
              }
              throw _context9.t0;
            case 12:
              _context9.next = 14;
              return _classPrivateFieldLooseBase(this, _getAuthToken)[_getAuthToken]();
            case 14:
              authTokenAfter = _context9.sent;
              if (!(!_context9.t0.isAuthError || !authTokenAfter)) {
                _context9.next = 17;
                break;
              }
              throw _context9.t0;
            case 17:
              if (_classPrivateFieldLooseBase(this, _refreshingTokenPromise)[_refreshingTokenPromise] == null) {
                // Many provider requests may be starting at once, however refresh token should only be called once.
                // Once a refresh token operation has started, we need all other request to wait for this operation (atomically)
                _classPrivateFieldLooseBase(this, _refreshingTokenPromise)[_refreshingTokenPromise] = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  var response;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.prev = 0;
                        _this3.uppy.log("[CompanionClient] Refreshing expired auth token", 'info');
                        _context8.next = 4;
                        return _get(_getPrototypeOf(Provider.prototype), "request", _this3).call(_this3, {
                          path: _this3.refreshTokenUrl(),
                          method: 'POST'
                        });
                      case 4:
                        response = _context8.sent;
                        _context8.next = 7;
                        return _this3.setAuthToken(response.uppyAuthToken);
                      case 7:
                        _context8.next = 15;
                        break;
                      case 9:
                        _context8.prev = 9;
                        _context8.t0 = _context8["catch"](0);
                        if (!_context8.t0.isAuthError) {
                          _context8.next = 14;
                          break;
                        }
                        _context8.next = 14;
                        return _this3.removeAuthToken();
                      case 14:
                        throw _context9.t0;
                      case 15:
                        _context8.prev = 15;
                        _classPrivateFieldLooseBase(_this3, _refreshingTokenPromise)[_refreshingTokenPromise] = undefined;
                        return _context8.finish(15);
                      case 18:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[0, 9, 15, 18]]);
                }))();
              }
              _context9.next = 20;
              return _classPrivateFieldLooseBase(this, _refreshingTokenPromise)[_refreshingTokenPromise];
            case 20:
              return _context9.abrupt("return", _get(_getPrototypeOf(Provider.prototype), "request", this).apply(this, _args9));
            case 21:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[2, 8]]);
      }));
      function request() {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "fetchPreAuthToken",
    value: function () {
      var _fetchPreAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var res;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (this.companionKeysParams) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              _context10.prev = 2;
              _context10.next = 5;
              return this.post("".concat(this.id, "/preauth/"), {
                params: this.companionKeysParams
              });
            case 5:
              res = _context10.sent;
              this.preAuthToken = res.token;
              _context10.next = 12;
              break;
            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](2);
              this.uppy.log("[CompanionClient] unable to fetch preAuthToken ".concat(_context10.t0), 'warning');
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[2, 9]]);
      }));
      function fetchPreAuthToken() {
        return _fetchPreAuthToken.apply(this, arguments);
      }
      return fetchPreAuthToken;
    }()
  }, {
    key: "list",
    value: function list(directory, options) {
      return this.get("".concat(this.id, "/list/").concat(directory || ''), options);
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(options) {
        var response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.get("".concat(this.id, "/logout"), options);
            case 2:
              response = _context11.sent;
              _context11.next = 5;
              return this.removeAuthToken();
            case 5:
              return _context11.abrupt("return", response);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function logout(_x5) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }]);
  return Provider;
}(RequestClient);
export { Provider as default };
function _getAuthToken2() {
  return _getAuthToken3.apply(this, arguments);
}
function _getAuthToken3() {
  _getAuthToken3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", _classPrivateFieldLooseBase(this, _getPlugin)[_getPlugin]().storage.getItem(this.tokenKey));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12, this);
  }));
  return _getAuthToken3.apply(this, arguments);
}
function _getPlugin2() {
  var plugin = this.uppy.getPlugin(this.pluginId);
  if (plugin == null) throw new Error('Plugin was nullish');
  return plugin;
}